// The walk matrix. Six or seven stages, entered by hand from a site map and
// corrected against experience. There is no data source for it and it drives every
// compromise calculation in the product, so it is worth being approximately right
// and worth being obviously editable.

import type { Id, WalkMatrix } from './types.ts';
import { MINUTE } from './time.ts';

export function walkKey(a: Id, b: Id): string {
  return a < b ? `${a}|${b}` : `${b}|${a}`;
}

export function walkMinutes(walk: WalkMatrix, a: Id, b: Id): number {
  if (a === b) return 0;
  const v = walk.minutes[walkKey(a, b)];
  return v === undefined ? walk.defaultMinutes : v;
}

export function walkMs(walk: WalkMatrix, a: Id, b: Id): number {
  return walkMinutes(walk, a, b) * MINUTE;
}

export function setWalkMinutes(walk: WalkMatrix, a: Id, b: Id, minutes: number): WalkMatrix {
  if (a === b) return walk;
  return { ...walk, minutes: { ...walk.minutes, [walkKey(a, b)]: minutes } };
}

/** Every unordered pair, for rendering an editable matrix. */
export function walkPairs(stageIds: Id[]): [Id, Id][] {
  const out: [Id, Id][] = [];
  for (let i = 0; i < stageIds.length; i++) {
    for (let j = i + 1; j < stageIds.length; j++) out.push([stageIds[i], stageIds[j]]);
  }
  return out;
}
